import * as React from "react";
const SVGLOGO = (props) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 206.53 112.49"
    {...props}
  >
    <defs>
    
    </defs>
    <g id="Layer_1-2" data-name="Layer 1">
      <g>
        <g>
          <polygon
            className="cls-1"
            points="67.44 39.58 55.95 39.58 55.95 112.44 72.58 112.44 72.58 29.93 67.44 32.76 67.44 39.58"
          />
          <polygon
            className="cls-1"
            points="190.5 39.58 185.36 39.58 185.36 29.93 180.22 32.76 180.22 39.58 175.08 39.58 175.08 29.93 169.94 32.76 169.94 39.58 101.11 39.58 101.11 29.93 95.97 32.76 95.97 39.6 83.44 39.58 83.44 0 78 2.72 78 112.44 97.45 112.44 190.17 112.44 195.64 112.44 195.62 39.59 195.64 39.59 195.64 29.93 190.5 32.76 190.5 39.58"
          />
          <polygon
            className="cls-1"
            points="206.5 0 201.06 2.71 201.06 112.44 206.53 112.44 206.5 0"
          />
          <polygon
            className="cls-1"
            points="108.04 13.44 118.64 24.04 129.46 13.21 118.64 2.39 108.04 12.99 97.44 2.39 86.62 13.21 97.44 24.04 108.04 13.44"
          />
          <rect
            className="cls-1"
            x={56.17}
            y={5.56}
            width={15.3}
            height={15.3}
            transform="translate(9.35 49) rotate(-45)"
          />
          <polygon
            className="cls-1"
            points="29.17 13.45 28.27 10.1 24.64 10.1 25.66 13.45 18.29 12.77 20.9 4.94 18.52 5.85 13.75 18.89 24.64 19.91 29.17 13.45"
          />
          <path
            className="cls-1"
            d="M43.38,18.38l-10.21,10.21.04.04-.04.04,9.57,10.96-36.55-.05,4.32-9.61h-5.59L.01,39.63v7.26s-.01.02-.01.02h0s.11,65.58.11,65.58h50.42V39.58l-10.13-10.96,10.13-10.13-7.15-.12ZM36.09,85.65l-10.82,10.82-10.82-10.82,10.6-10.6-10.6-10.6,10.82-10.82,10.82,10.82-10.6,10.6,10.6,10.6Z"
          />
        </g>
        <polygon
          className="cls-1"
          points="186.65 3.56 186.59 8.1 181.78 11.41 188.07 13.83 185.65 18.6 175.11 21.29 176.64 17.02 182.66 15.55 178.28 13.58 179.06 9.71 186.65 3.56"
        />
      </g>
    </g>
  </svg>
);
export default SVGLOGO;
